const { Criteria } = Shopware.Data;
const { Mixin } = Shopware;

// Alle neun Gefahrenpiktogramme nach CLP Anhang V
const PICTOGRAMS = [
    { value: 'GHS01', label: 'GHS01 – explosiv (explodierende Bombe)' },
    { value: 'GHS02', label: 'GHS02 – entzündbar (Flamme)' },
    { value: 'GHS03', label: 'GHS03 – brandfördernd (Flamme über Kreis)' },
    { value: 'GHS04', label: 'GHS04 – Gase unter Druck (Gasflasche)' },
    { value: 'GHS05', label: 'GHS05 – ätzend (Ätzwirkung)' },
    { value: 'GHS06', label: 'GHS06 – giftig (Totenkopf)' },
    { value: 'GHS07', label: 'GHS07 – gesundheitsschädlich oder reizend (Ausrufezeichen)' },
    { value: 'GHS08', label: 'GHS08 – Gesundheitsgefahr' },
    { value: 'GHS09', label: 'GHS09 – gewässergefährdend (Umwelt)' },
];

export default {
    template: `
<sw-page class="riccardo-compliance-detail">
    <template #smart-bar-header><h2>{{ profile ? (profile.name || 'Neues Profil') : '' }}</h2></template>
    <template #smart-bar-actions>
        <sw-button :router-link="{ name: 'riccardo.compliance.list' }">Abbrechen</sw-button>
        <sw-button-process variant="primary" :is-loading="isLoading" :process-success="isSaveSuccessful" @click="onSave">Speichern</sw-button-process>
    </template>
    <template #content>
        <sw-card-view v-if="profile">
            <sw-card title="Profil" :is-loading="isLoading">
                <sw-container columns="2fr 1fr 1fr" gap="0 24px">
                    <sw-text-field v-model:value="profile.name" label="Name des Profils" required
                                   help-text="Nur intern, z. B. „Nikotinsalz-Liquids 10–20 mg“." />
                    <sw-number-field v-model:value="profile.priority" number-type="int" label="Priorität"
                                     help-text="Bei mehreren passenden Profilen gewinnt die höhere Priorität." />
                    <sw-switch-field v-model:value="profile.active" label="Aktiv" />
                </sw-container>
            </sw-card>

            <sw-card title="Gilt für" :is-loading="isLoading">
                <sw-entity-multi-select v-model:entity-collection="profile.categories" label="Kategorien"
                                        help-text="Alle Artikel dieser Kategorien erhalten die Angaben." />
                <sw-entity-multi-select v-model:entity-collection="profile.products" label="Einzelne Artikel"
                                        help-text="Eine direkte Zuweisung hat Vorrang vor der Kategorie." />
            </sw-card>

            <sw-card title="CLP-Kennzeichnung" :is-loading="isLoading">
                <sw-alert variant="info" style="margin-bottom: 16px">
                    Angaben aus dem Sicherheitsdatenblatt des Herstellers übernehmen. Die im Shop gezeigten
                    Piktogramme sind nachgezeichnet – für den Livegang die amtlichen Vorlagen (CLP Anhang V) einsetzen.
                </sw-alert>
                <sw-container columns="1fr 2fr" gap="0 24px">
                    <sw-single-select v-model:value="profile.signalWord" label="Signalwort" :options="signalOptions" />
                    <sw-multi-select v-model:value="pictograms" label="Piktogramme" :options="pictogramOptions" @update:value="v => profile.pictograms = v" />
                </sw-container>
                <sw-multi-tag-select :value="containsList" label="Enthält" placeholder="Nikotin, Propylenglykol …" @update:value="v => profile.contains = v" />

                <h4 style="margin-top: 24px">Gefahrenhinweise (H-Sätze)</h4>
                <div v-for="(row, index) in hazardRows" :key="'h' + index" style="display: grid; grid-template-columns: 160px 1fr auto; gap: 16px; align-items: end;">
                    <sw-text-field v-model:value="row.code" label="Code" placeholder="H301" />
                    <sw-text-field v-model:value="row.text" label="Text" placeholder="Giftig bei Verschlucken." />
                    <sw-button variant="danger" style="margin-bottom: 22px" @click="hazardRows.splice(index, 1)">Entfernen</sw-button>
                </div>
                <sw-button @click="hazardRows.push({ code: '', text: '' })">H-Satz hinzufügen</sw-button>

                <h4 style="margin-top: 24px">Sicherheitshinweise (P-Sätze)</h4>
                <div v-for="(row, index) in precautionRows" :key="'p' + index" style="display: grid; grid-template-columns: 160px 1fr auto; gap: 16px; align-items: end;">
                    <sw-text-field v-model:value="row.code" label="Code" placeholder="P102" />
                    <sw-text-field v-model:value="row.text" label="Text" placeholder="Darf nicht in die Hände von Kindern gelangen." />
                    <sw-button variant="danger" style="margin-bottom: 22px" @click="precautionRows.splice(index, 1)">Entfernen</sw-button>
                </div>
                <sw-button @click="precautionRows.push({ code: '', text: '' })">P-Satz hinzufügen</sw-button>

                <sw-textarea-field v-model:value="profile.warning" label="Pflichthinweis am Kaufbereich" style="margin-top: 24px"
                                   help-text="Kurzer Satz, erscheint direkt beim Warenkorb-Button, z. B. der Nikotinhinweis." />
            </sw-card>

            <sw-card title="Hersteller & Verantwortlicher (GPSR)" :is-loading="isLoading">
                <sw-container columns="1fr 1fr" gap="0 24px">
                    <sw-text-field v-model:value="profile.manufacturerName" label="Hersteller" />
                    <sw-text-field v-model:value="profile.manufacturerEmail" label="E-Mail des Herstellers" />
                </sw-container>
                <sw-textarea-field v-model:value="profile.manufacturerAddress" label="Anschrift des Herstellers" />
                <sw-container columns="1fr 1fr" gap="0 24px">
                    <sw-text-field v-model:value="profile.responsibleName" label="Verantwortliche Person in der EU" />
                    <sw-text-field v-model:value="profile.responsibleEmail" label="E-Mail" />
                </sw-container>
                <sw-textarea-field v-model:value="profile.responsibleAddress" label="Anschrift" />
                <sw-text-field v-model:value="profile.responsibleUrl" label="Internetadresse" />
            </sw-card>

            <sw-card title="Dokumente & Hinweise" :is-loading="isLoading">
                <sw-upload-listener :upload-tag="uploadTag" auto-upload @media-upload-finish="onMediaUpload" />
                <sw-media-upload-v2 :upload-tag="uploadTag" :source="profile.sdsMediaId" label="Sicherheitsdatenblatt (PDF)"
                                    default-folder="cms_page" @media-drop="onMediaDrop" @media-upload-remove-image="profile.sdsMediaId = null" />
                <sw-textarea-field v-model:value="profile.additionalInfo" label="Weitere Hinweise (HTML erlaubt)" />
            </sw-card>
        </sw-card-view>
    </template>
</sw-page>`,

    inject: ['repositoryFactory'],

    mixins: [Mixin.getByName('notification')],

    props: {
        profileId: { type: String, required: false, default: null },
    },

    data() {
        return {
            profile: null,
            hazardRows: [],
            precautionRows: [],
            isLoading: false,
            isSaveSuccessful: false,
            uploadTag: 'riccardo-compliance-sds',
        };
    },

    computed: {
        repository() {
            return this.repositoryFactory.create('riccardo_compliance_profile');
        },
        signalOptions() {
            return [
                { value: null, label: 'kein Signalwort' },
                { value: 'warning', label: 'Achtung' },
                { value: 'danger', label: 'Gefahr' },
            ];
        },
        pictogramOptions() {
            return PICTOGRAMS;
        },
        pictograms() {
            return this.profile?.pictograms || [];
        },
        containsList() {
            return this.profile?.contains || [];
        },
    },

    created() {
        this.load();
    },

    methods: {
        load() {
            if (!this.profileId) {
                this.profile = this.repository.create();
                this.profile.active = true;
                this.profile.priority = 0;
                this.profile.pictograms = [];
                this.profile.contains = [];
                this.hazardRows = [];
                this.precautionRows = [];
                return Promise.resolve();
            }
            this.isLoading = true;
            const criteria = new Criteria();
            criteria.addAssociation('products');
            criteria.addAssociation('categories');
            return this.repository.get(this.profileId, Shopware.Context.api, criteria).then((profile) => {
                this.profile = profile;
                this.profile.pictograms = profile.pictograms || [];
                this.profile.contains = profile.contains || [];
                this.hazardRows = [...(profile.hazardStatements || [])];
                this.precautionRows = [...(profile.precautionaryStatements || [])];
            }).finally(() => { this.isLoading = false; });
        },

        onMediaUpload({ targetId }) {
            this.profile.sdsMediaId = targetId;
        },
        onMediaDrop(media) {
            this.profile.sdsMediaId = media.id;
        },

        onSave() {
            const clean = (rows) => rows
                .map((row) => ({ code: (row.code || '').trim(), text: (row.text || '').trim() }))
                .filter((row) => row.code || row.text);

            this.profile.hazardStatements = clean(this.hazardRows);
            this.profile.precautionaryStatements = clean(this.precautionRows);

            this.isLoading = true;
            this.isSaveSuccessful = false;
            return this.repository.save(this.profile).then(() => {
                this.isSaveSuccessful = true;
                this.createNotificationSuccess({ message: 'Pflichtangaben gespeichert' });
                if (!this.profileId) {
                    this.$router.push({ name: 'riccardo.compliance.detail', params: { id: this.profile.id } });
                    return Promise.resolve();
                }
                return this.load();
            }).catch(() => {
                this.createNotificationError({ message: 'Speichern fehlgeschlagen.' });
            }).finally(() => { this.isLoading = false; });
        },
    },
};
